import { CONFIG } from "../config";
import { updateThemeMode } from "./updateThemeMode";

/**
 * Gère le changement de thème (toggle ou initialisation)
 * @param {string|null} mode - Si null, toggle entre dark/light. Sinon, applique le mode spécifié.
 */
export default async function handleThemeChange(mode = null) {
  // Si un mode spécifique est demandé, l'appliquer directement
  if (mode !== null) {
    updateThemeMode(mode);
    return;
  }

  // Sinon, toggle entre les modes
  let theme = localStorage.getItem("theme");

  if (theme === null) {
    // Pas de préférence sauvegardée, utiliser le thème par défaut
    updateThemeMode(CONFIG.defaultTheme || "dark");
  } else if (theme === "light") {
    updateThemeMode("dark");
  } else {
    updateThemeMode("light");
  }
}

/**
 * Initialise le thème au chargement de l'application
 * Doit être appelé au démarrage pour appliquer le data-theme attribute
 */
export function initializeTheme() {
  const savedTheme = localStorage.getItem("theme");
  const theme = savedTheme || CONFIG.defaultTheme || "dark";

  // Appliquer l'attribut data-theme immédiatement
  document.documentElement.setAttribute("data-theme", theme);

  return theme;
}
